import { Suspense, lazy } from 'react';

import { Loading } from '../Loading';

import type { MapProps } from './types/map/props.type';

const Map = lazy(() =>
  import('./index').then((module) => ({
    default: module.Map,
  })),
);

export const LazyMap = (props: Readonly<MapProps>) => (
  <Suspense fallback={<Loading />}>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <Map {...props} />
  </Suspense>
);
